module.exports = __webpack_public_path__ + "img/selected0-min.afada9d5.png";